import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

type TProps = {
  /** Mirrors `ClientDocument`, so the skeleton lays out like the document it stands in for. */
  summaryPlacement?: 'sidebar' | 'stacked';
};

const SummaryCard: FC = () => (
  <Card sizeVariant="lg">
    <Card.Body className="flex flex-col gap-4">
      <SkeletonLoader.Title className="w-1/3" />

      <hr className="hr my-4" />

      <SkeletonLoader.Text />
      <SkeletonLoader.Text />
      <SkeletonLoader.Text />

      <hr className="hr my-4" />
    </Card.Body>
  </Card>
);

const ClientDocumentLoading: FC<TProps> = (props) => {
  const { summaryPlacement = 'sidebar' } = props;

  const isStacked = summaryPlacement === 'stacked';
  const rowClassName = isStacked
    ? ''
    : '@screen-md:grid-cols-5 @screen-lg:grid-cols-3 grid grid-cols-1 gap-8 ';
  const documentColumnClassName = isStacked
    ? ''
    : '@screen-md:col-span-3 @screen-lg:col-span-2 ';

  return (
    <div className="@container">
      <div className={rowClassName + 'w-full'}>
        <div className={documentColumnClassName + 'space-y-8'}>
          <Card sizeVariant="lg">
            <Card.Body>
              <div className="flex flex-col items-end gap-4">
                <SkeletonLoader.Title className="w-1/6" />
                <SkeletonLoader.Text className="w-1/4" />

                <hr className="hr my-4" />

                <SkeletonLoader.Text />
                <SkeletonLoader.Text />
                <SkeletonLoader.Text />
              </div>
            </Card.Body>
          </Card>

          <Card sizeVariant="lg">
            <Card.Body>
              <div className="space-y-4">
                <SkeletonLoader.Title className="w-1/6" />

                <SkeletonLoader className="h-28 rounded-lg" />
                <SkeletonLoader className="h-28 rounded-lg" />
                <SkeletonLoader className="h-28 rounded-lg" />

                <div className="flex flex-col items-end gap-4">
                  <SkeletonLoader.Text className="w-1/12" />
                  <SkeletonLoader.Text className="w-1/12" />
                </div>
              </div>
            </Card.Body>
          </Card>

          {isStacked && <SummaryCard />}

          <Card sizeVariant="lg">
            <Card.Body>
              <div className="space-y-4">
                <SkeletonLoader.Title className="w-1/6" />

                <SkeletonLoader className="h-28 rounded-lg" />
              </div>
            </Card.Body>
          </Card>

          <Card sizeVariant="lg">
            <Card.Body>
              <div className="space-y-4">
                <SkeletonLoader.Title className="w-1/6" />

                <SkeletonLoader className="h-28 rounded-lg" />
              </div>
            </Card.Body>
          </Card>
        </div>

        {!isStacked && (
          <div className="@screen-md:block @screen-md:col-span-2 @screen-lg:col-span-1 hidden space-y-4">
            <SummaryCard />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientDocumentLoading;
